<template>
  <div id="actionSupport">
    <el-popover placement="top-end" trigger="manual" popper-class="context" :value="popoverVisible">
      <pre>{{ hasHovered ? $t('ActionSupport.NeedHelp') : $t('ActionSupport.HaveQuestions') }}</pre>
      <template #reference>
        <div
          class="float-icon__entry"
          @click="openActionSupportDialog"
          @mouseenter="onMouseEnter"
          @mouseleave="onMouseLeave"
        >
          <img src="@/assets/img/actionSupport/side-btn.svg" alt="actionSupport">
        </div>
      </template>
    </el-popover>

    <el-dialog
      :visible.sync="isShowActionSupportDialog"
      :close-on-click-modal="false"
      width="90%"
      center
    >
      <template #title>
        <div class="title-wrapper">
          <div class="logo">
            <img src="@/assets/img/actionSupport/logo.svg" alt="logo">
          </div>
          <div class="title">
            {{ $t("ActionSupport.Title") }}
          </div>
        </div>
      </template>
      <iframe
        width="100%"
        height="100%"
        :src="link"
        frameborder="0"
      >
      </iframe>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShowActionSupportDialog: false,
      link: '',
      popoverVisible: false,
      hasHovered: false,
      hideTimer: null,
      AUTO_CLOSE_DELAY_MS: 30 * 1000 // 30秒後自動關閉提示
    }
  },
  watch: {
    $route (to, from) {
      this.hasHovered = false
      this.popoverVisible = true
      this.startAutoCloseTimer()
    }
  },
  mounted () {
    this.popoverVisible = true
    this.startAutoCloseTimer()
  },
  beforeDestroy () {
    clearTimeout(this.hideTimer)
  },
  methods: {
    startAutoCloseTimer () {
      clearTimeout(this.hideTimer)
      this.hideTimer = setTimeout(() => {
        this.popoverVisible = false
      }, this.AUTO_CLOSE_DELAY_MS)
    },
    onMouseEnter () {
      clearTimeout(this.hideTimer)
      this.hasHovered = true
      this.popoverVisible = true
    },
    onMouseLeave () {
      this.popoverVisible = false
    },
    openActionSupportDialog () {
      // Sentry MGMT-MX: 避免在初始化 data 時呼叫 $getCookie 導致零星取不到資料的錯誤
      const comLoginToken = this.$getCookie('comLoginToken').replace('token=', '')
      this.link = `${process.env.VUE_APP_ACTION_SUPPORT_WEB_URL}?timestamp=${Date.now()}&comLoginToken=${encodeURIComponent(comLoginToken)}`
      this.isShowActionSupportDialog = true
      this.$sendGAEvent('幫助中心使用數', {
        value: 'click_幫助中心'
      })
    },
    closeActionSupportDialog () {
      this.isShowActionSupportDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
$dialogHeaderHeight: 64px;
.float-icon__entry {
  border-radius: 100%;
  width: 80px;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: map-get($fontSize,medium);
  font-weight: 700;
  text-align: center;
  color: white;
  transform: translate3d(0, 0, 0); // 使動畫更加流暢
  transition: transform ease-out 200ms;
  cursor: pointer;
  position: fixed;
  bottom: 235px; // 先維持既有寫死的方式，每次 + 100px
  right: 30px;
  z-index: 20;

  &:hover {
    transform: scale(1.2, 1.2) translate3d(0, 0, 0);
  }

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    image-rendering: -webkit-optimize-contrast;
    backface-visibility: hidden;
  }
}
::v-deep .el-dialog {
  @include basicDialog();
  margin-top: 5vh !important;
  margin-bottom: 5vh !important;
  height: 90vh;
  .el-dialog__header {
    position: relative;
    height: $dialogHeaderHeight;
    padding: 0 24px 0 32px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: $white !important;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
    .title-wrapper {
      display: flex;
      align-items: center;
    }
    .logo {
      height: 32px;
      margin-right: 12px;
      & > img {
        height: 100%;
      }
    }
    .title {
      font-size: map-get($fontSize, large);
      font-weight: 600;
      color: $grayFontColor;
    }
  }
  .el-dialog__headerbtn {
    position: relative;
    top: unset;
    right: unset;
  }
  .el-dialog__close {
    font-size: map-get($fontSize, xxx-large);
  }
  .el-dialog__body{
    height: calc(100% - $dialogHeaderHeight);
    width: 100%;
    max-height: unset;
    padding: 0;
    overflow: hidden;
  }
}
</style>
